import { ElementRef, Directive, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appNumericOnly]'
})
export class NumericOnlyDirective {

  name: string;

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.name = el.nativeElement.name;

    renderer.listen(el.nativeElement, 'keypress', (event) => {
    if (event.ctrlKey || event.metaKey || event.altKey) {
        return true;
    }
    const charCode = (event.which) ? event.which : event.keyCode;
    const isAlpha = ((charCode >= 32) && (charCode <= 47)) || (charCode > 57);
    return !isAlpha;
});
  }
}
